<style scoped>

  .money.input {
    width: 120px;
  }

</style>

<template>
  <div :id="_uid" class="ui small input">
    <input class="money input" :value="valueInput" @blur="valueInput = $event.target.value">
  </div>
</template>

<script>

  import Input from "@/utils/input"

  export default {
    
    name: "AnticipationValueInput",

    data() {
      return {
        ctx: { value: 0 },
      }
    },

    props: ["index", "cert"],

    created() {
      if (this.cert.anticipation.action == "credit") {
        this.ctx.value = this.cert.anticipation.creditValue
      } else if (this.cert.anticipation.action == "debit") {
        this.ctx.value = this.cert.anticipation.debitValue
      }
    },

    mounted() {
      Input.maskCurrency()
    },

    computed: {
      valueInput: {
        get() {
          return Input.currencyToString(this.ctx.value)
        },
        set(str) {
          const value = Input.stringToCurrency(str)
          this.$set(this.ctx, "value", value)
          this.$emit("onBlur", { index: this.index, value })
        },
      },
    },
  }

</script>